import {AfterViewInit, Component, OnDestroy, OnInit} from '@angular/core';
import {IMerchant} from './IMerchant';
import {NgxSpinnerService} from 'ngx-spinner';
import {MerchantsService} from './merchants-service';
import {HttpErrorValidator} from '../services/http-error-validator';
import {Router} from '@angular/router';
import {MerchantListComponent} from './merchant-list.component';
import * as $ from 'jquery';

@Component({
  selector: 'pm-search-merchant',
  templateUrl: './search-merchant.component.html',
  styleUrls: ['./search-merchant.component.sass']
})
export class SearchMerchantComponent implements OnInit, OnDestroy, AfterViewInit {

  Comercio: IMerchant[] = [];
  currentPg = 1;

  constructor(private spinnerService: NgxSpinnerService, private parent: MerchantListComponent, private router: Router,
              private comerciosService: MerchantsService,
              private httpErrorValidator: HttpErrorValidator) {
  }

  ngOnInit(): void {
    this.Comercio = this.parent.resultadosBusqueda;
  }

  newComercio(): void {
    this.parent.showEditComercios = false;
    this.parent.showComercios = false;
    this.parent.showAddComercios = true;
    this.parent.showEditRolComercios = false;
    this.parent.showModalComercios = false;
    this.parent.showSearchMerchant = false;
  }

  edit(elemento) {
    this.parent.editnumber = elemento.id;
    this.parent.showEditComercios = true;
    this.parent.showComercios = false;
    this.parent.showAddComercios = false;
    this.parent.showEditRolComercios = false;
    this.parent.showModalComercios = false;
    this.parent.showSearchMerchant = false;
  }

  public spinner(): void {
    this.spinnerService.show();
  }

  public stopSpinner(): void {
    this.spinnerService.hide();
  }

  ngOnDestroy() {
    $('a[rel=comercios]').removeClass('selected');
  }

  ngAfterViewInit() {
    $('a[rel=comercios]').addClass('selected');
  }

}
